module.exports = __webpack_public_path__ + "img/tiethai.e5d286dd.png";